module.exports = __webpack_public_path__ + "fdcd725da922be2275db5ec931926221.png";